<template>
    <div class="intro-list">
        <heading title="Intro Paragraphs" tag="intro-list-title">
            <b-button v-if="canCreate"
                      variant="primary"
                      :to="{name:'introCreate'}">
                Add Intro Paragraph
            </b-button>
        </heading>
        <data-table ref="dataTable"
                    persistName="intro-filter"
                    :show-filters="true"
                    :show-pager="true"
                    :get-items="getEntries"
                    v-model="filters"
                    :fields="fields">
            <!-- template for custom columns -->
            <template v-slot:customField="slotProps">
                <template v-if="slotProps.row.field.key === 'content'">
                    {{ stripTags(slotProps.row.item[slotProps.row.field.key]) }}
                </template>
                <template v-else-if="slotProps.row.field.key === 'actions'">
                    <div class="d-flex">
                        <b-button size="sm" variant="secondary"
                                  class="mr-2"
                                  :to="{ name: 'introView', params: { introId : slotProps.row.item.id }}">
                            <b-icon-eye/>
                        </b-button>
                        <b-button size="sm" variant="secondary"
                                  class="mr-2"
                                  :to="{ name: 'introEdit', params: { introId : slotProps.row.item.id }}">
                            <b-icon-pencil-square/>
                        </b-button>
                    </div>
                </template>
            </template>
        </data-table>
    </div>
</template>

<script>
import Vue from 'vue'
import Intro from '@/models/Intro'
import Authorization from '@/providers/Authorization'

export default Vue.extend({
    name: 'IntroList',
    data () {
        return {
            introFields: Intro,
            fields: [
                { key: 'route', sortable: true, label: 'Route' },
                { key: 'content', sortable: false, label: 'Content' },
                { key: 'actions', sortable: false },
            ],
            filters: {
                route: { field: 'route', type: 'string', value: null, label: 'Route' },
                content: { field: 'content', type: 'string', value: null, label: 'Content' },
            },
            canCreate: false,
        }
    },
    created () {
        Authorization.can({ action: 'create', model: 'intro' })
            .then((can) => this.canCreate = can)
    },
    methods: {
        getEntries (listParams) {
            return this.$api.getItems(this, 'intro', this.filters, listParams)
        },
        stripTags (value) {
            let div = document.createElement('div')
            div.innerHTML = value
            return div.textContent || div.innerText || ''
        },
    }
})
</script>
